// extracted by mini-css-extract-plugin
export default {"trusted":"Trusted_trusted__a5XVa"};